import { FY_START_MONTH } from '../omnidashboard.config';

export interface FiscalYearOption {
  label: string;
  value: string;
}

export interface FiscalYearOptionsResult {
  selectedFiscalYear: string;
  options: FiscalYearOption[];
}

export function buildFiscalYearOptions(now: Date = new Date()): FiscalYearOptionsResult {
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  // FY starts in April (FY_START_MONTH): Jan–Mar belong to the calendar year's FY label.
  const currentFy = month < FY_START_MONTH ? year : year + 1;
  const fyList = [String(currentFy + 1), String(currentFy), String(currentFy - 1)];
  return {
    selectedFiscalYear: String(currentFy),
    options: fyList.map((fy) => ({ label: `FY${fy.slice(-2)}`, value: fy })),
  };
}
